// Module
var code = "<mx-checkbox flex=\"90\" ng-model=\"vm.condition.value\" label=\"{{vm.condition.value ? vm.i18n.true : vm.i18n.false}}\">\r\n</mx-checkbox>";
// Exports
export default code;